document.addEventListener('DOMContentLoaded', function() {
  // Wait a tiny moment to ensure theme JS initializes sliders first
  setTimeout(function() {
    document.querySelectorAll('.collection-list-slider').forEach(function(container) {
      // Destroy existing carousel if it exists
      if (container.carousel) {
        container.carousel.destroy(true, true);
      }

      // Read dataset values
      const productsPerView = parseInt(container.dataset.productsPerView, 10) || 4;
      const mobileProductsPerView = parseInt(container.dataset.mobileProductsPerView, 10) || 2;

      // Re-initialize Carousel with custom gaps and flush edges
      container.carousel = Carousel(container, {
        slidesPerView: mobileProductsPerView * 1.05, // mobile
        spaceBetween: 6, // default gap
        breakpoints: {
          720: {
            slidesPerView: productsPerView === 5 ? productsPerView - 1 : productsPerView,
            spaceBetween: 6
          },
          1200: {
            slidesPerView: productsPerView,
            spaceBetween: 6
          }
        },
        navigation: {
          nextEl: container.querySelector('.carousel__navigation-button--forward'),
          prevEl: container.querySelector('.carousel__navigation-button--back')
        }
      });

      // Flush first and last slides
      const wrapper = container.querySelector('.carousel__wrapper');
      if (wrapper) {
        wrapper.style.paddingLeft = '0';
        wrapper.style.paddingRight = '0';
      }
    });
  }, 100); // 100ms delay to allow theme JS to finish
});

